var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "question-mark",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.794,
    height: 18.099,
    viewBox: "0 0 12.794 18.099",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_42715",
    "data-name": "Path 42715",
    d: "M397.28,788.2h-.874a1.117,1.117,0,0,0-1.116,1.116v1.207a1.117,1.117,0,0,0,1.116,1.116h.874a1.117,1.117,0,0,0,1.116-1.116v-1.207A1.116,1.116,0,0,0,397.28,788.2Z",
    transform: "translate(-390.59 -773.539)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_42716",
    "data-name": "Path 42716",
    d: "M143.136,5.316l1.613.2a1.117,1.117,0,0,0,1.181-.712,3.44,3.44,0,0,1,.971-1.438,3.29,3.29,0,0,1,2.193-.744,3.147,3.147,0,0,1,2.163.712,2.211,2.211,0,0,1,.8,1.713,2.132,2.132,0,0,1-.452,1.317,14.921,14.921,0,0,1-1.8,1.6,7.577,7.577,0,0,0-2.007,2.2,5.084,5.084,0,0,0-.491,2.145,1.116,1.116,0,0,0,1.116,1.162h.911a1.118,1.118,0,0,0,1.112-1.021,2.817,2.817,0,0,1,.21-.943,5.24,5.24,0,0,1,1.352-1.453,14.039,14.039,0,0,0,2.749-2.758,3.949,3.949,0,0,0,.644-2.148,4.676,4.676,0,0,0-1.748-3.6A6.846,6.846,0,0,0,148.95,0a6.608,6.608,0,0,0-4.54,1.525A5.261,5.261,0,0,0,142.62,4.6.6.6,0,0,0,143.136,5.316Z",
    transform: "translate(-142.61 0)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIcon);
export default __webpack_public_path__ + "static/media/questionIcon.dc2719e6cda541110bc998d2f118a2a4.svg";
export { ForwardRef as ReactComponent };